import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { appStoreLinkForBrowser } from '../../core/utils/tag-link';
import { ButtonComponent } from '../../shared/components/button/button.component';
import { CardContentComponent } from '../../shared/components/card/card-content.component';
import { CardComponent } from '../../shared/components/card/card.component';
import { IconComponent } from '../../shared/components/icon/icon.component';
import { TranslatePipe } from '../../shared/pipes/translate.pipe';

/**
 * Landing page for a tag link opened in a mobile browser (the app isn't installed).
 * Offers the store listing, or carrying on in the browser. Only reached when a store
 * link exists for this platform — see tagLinkLandingGuard.
 */
@Component({
  selector: 'app-tag-link',
  imports: [CardComponent, CardContentComponent, ButtonComponent, IconComponent, TranslatePipe],
  templateUrl: './tag-link.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './tag-link.component.css',
})
export class TagLinkComponent {
  private router = inject(Router);
  private code = inject(ActivatedRoute).snapshot.paramMap.get('code') ?? '';
  private storeLink = appStoreLinkForBrowser(navigator.userAgent);

  getApp(): void {
    if (this.storeLink) window.location.href = this.storeLink;
  }

  continueInBrowser(): void {
    this.router.navigate(['/t', this.code, 'open'], { replaceUrl: true });
  }
}
